import { Injectable } from '@angular/core';
import { ResponseCommonSI } from '@interfaces/services/common.interfaces';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BASE_URL, ENDPOINTS } from '@core/config/constants';
import { BasicInformationIS } from '@views/interfaces/services/basicInformation.interfaces';

@Injectable({
  providedIn: 'root',
})
export class BasicInformationService {
  constructor(private http: HttpClient) {}

  async save(body: BasicInformationIS): Promise<{ IdBasicInformation: string }> {
    const result = await firstValueFrom<ResponseCommonSI<{ IdBasicInformation: string }>>(
      this.http.post(`${BASE_URL}${ENDPOINTS.BASIC_INFORMATION}`, body)
    );
    return result.payload;
  }
}
